import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function DeleteTemplate(){
    const {id} = useParams();
    const [templates, setTemplate] = useState([]);
    const navigate = useNavigate();
    const API_URL = BASE_URL+"/gettemplates";

    useEffect(() => {
        axios.get(API_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setTemplate(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error);
            }
        )
    }, [])

    const deleteEmail = () => {
        const DELETE_URL = BASE_URL+`/deletetemplate/${id}`;
        axios.delete(DELETE_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                navigate("/emails/email-templates");
                // console.log(res);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error);
            }
        )
    }
    const [loading, setLoading] = useState(true);
    if (loading) return <Loader />;
    return(
        <div className="container">
            <br /><br />
            {templates.filter(template => template.Id == id)
            .map(template => (
                <h2>Are you sure you want to delete <i>"{template.Country}"</i> template ?</h2>
            ))}
            <br />
            <button className="btn btn-danger" onClick={deleteEmail}>Yes Delete</button>
        </div>
    )
}